import ManagePageLayout from "@/component/common/layout/ManagePageLayout.tsx";
import ProtectAdminRouter from "@/component/common/protect-router/ProtectAdminRouter.tsx";
import ProtectManagerRouter from "@/component/common/protect-router/ProtectManagerRouter.tsx";
import { STATUS_PAGE_MAP } from "@/constant/constants.ts";
import { COMMON_PATH, MANAGER_PATH } from "@/constant/url-path.ts";
import ForgotPassword from "@/view/authentication/ForgotPassword.tsx";
import SignIn from "@/view/authentication/SignIn.tsx";
import ForbiddenPage from "@/view/ForbiddenPage.tsx";
import AddLicenseRegistrationPage from "@/view/license/AddLicenseRegistrationPage.tsx";
import LicenseRegistration from "@/view/license/LicenseRegistration.tsx";
import MainRoute from "@/view/MainRoute.tsx";
import CustomerInquiries from "@/view/manage/contacts/CustomerInquiries.tsx";
import ConversionRecord from "@/view/manage/conversion-record/index.tsx";
import CustomerRequest from "@/view/manage/customer/CustomerRequest.tsx";
import AddProductPage from "@/view/manage/product/AddProductPage.tsx";
import ProductManagement from "@/view/manage/product/ProductManagement.tsx";
import AddUserPage from "@/view/manage/user/AddUserPage.tsx";
import UserManagement from "@/view/manage/user/UserManagement.tsx";
import PageNotFound from "@/view/PageNotFound.tsx";
import UnAuthorizationPage from "@/view/UnAuthorizationPage.tsx";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./custom-style-lib.scss";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<MainRoute />}></Route>
          <Route path={MANAGER_PATH.AUTH.SIGN_IN} element={<SignIn />}></Route>
          <Route
            path={MANAGER_PATH.AUTH.FORGOT_PASSWORD}
            element={<ForgotPassword />}
          ></Route>
          <Route
            index={false}
            path={MANAGER_PATH.MANAGE}
            element={
              <ProtectManagerRouter>
                <ManagePageLayout />
              </ProtectManagerRouter>
            }
          >
            <Route
              path={MANAGER_PATH.LICENSE_REGISTRATION.LIST}
              element={<LicenseRegistration />}
            ></Route>
            <Route
              path={MANAGER_PATH.LICENSE_REGISTRATION.DETAIL}
              element={<AddLicenseRegistrationPage />}
            ></Route>
            <Route
              path={MANAGER_PATH.LICENSE_REGISTRATION.ADD}
              element={
                <AddLicenseRegistrationPage
                  statusPage={STATUS_PAGE_MAP.CREATE}
                />
              }
            ></Route>
            <Route
              path={MANAGER_PATH.LICENSE_REGISTRATION.EDIT}
              element={
                <AddLicenseRegistrationPage statusPage={STATUS_PAGE_MAP.EDIT} />
              }
            ></Route>
            <Route
              path={MANAGER_PATH.PRODUCT.LIST}
              element={<ProductManagement />}
            ></Route>
            <Route
              path={MANAGER_PATH.PRODUCT.ADD}
              element={<AddProductPage />}
            ></Route>
            <Route
              path={MANAGER_PATH.PRODUCT.EDIT}
              element={<AddProductPage isEdit={true} />}
            ></Route>

            <Route
              path={MANAGER_PATH.CUSTOMER.REQUEST}
              element={<CustomerRequest />}
            ></Route>
            <Route
              path={MANAGER_PATH.CONTACT.LIST}
              element={<CustomerInquiries />}
            ></Route>
            <Route
              path={MANAGER_PATH.CONVERSION_RECORD.LIST}
              element={<ConversionRecord />}
            ></Route>
            <Route
              path={MANAGER_PATH.USER.LIST}
              element={
                <ProtectAdminRouter>
                  <UserManagement />
                </ProtectAdminRouter>
              }
            ></Route>
            <Route
              path={MANAGER_PATH.USER.ADD}
              element={
                <ProtectAdminRouter>
                  <AddUserPage />
                </ProtectAdminRouter>
              }
            ></Route>
            <Route
              path={MANAGER_PATH.USER.EDIT}
              element={
                <ProtectAdminRouter>
                  <AddUserPage isEdit={true} />
                </ProtectAdminRouter>
              }
            ></Route>
          </Route>
          <Route path="*" element={<PageNotFound />} />
          <Route
            path={COMMON_PATH.UN_AUTHORIZATION}
            element={<UnAuthorizationPage />}
          />
          <Route path={COMMON_PATH.FORBIDDEN} element={<ForbiddenPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
